/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AwayInputs */

const th_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมเยือน`)
};

const en_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Away`)
};

const ja_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウェイ`)
};

const zh_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客队`)
};

const es_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitante`)
};

const pt_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitante`)
};

const id_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tandang`)
};

const fr_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extérieur`)
};

const tl_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisita`)
};

const vi_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách`)
};

const ko_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원정`)
};

const de_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswärts`)
};

const ru_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гости`)
};

const tr_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplasman`)
};

const it_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasferta`)
};

const pl_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyjazd`)
};

const uk_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гості`)
};

const hi_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाहर`)
};

const ar_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خارج الأرض`)
};

const ms_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luar`)
};

const bn_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাওয়ে`)
};

const zh_tw2_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客隊`)
};

const zh_hk2_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客隊`)
};

const ur_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مہمان`)
};

const fa_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میهمان`)
};

const sw_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugenini`)
};

const nl_away = /** @type {(inputs: AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uit`)
};

/**
* | output |
* | --- |
* | "Away" |
*
* @param {AwayInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const away = /** @type {((inputs?: AwayInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AwayInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_away(inputs)
	if (locale === "ja") return ja_away(inputs)
	if (locale === "zh") return zh_away(inputs)
	if (locale === "es") return es_away(inputs)
	if (locale === "pt") return pt_away(inputs)
	if (locale === "id") return id_away(inputs)
	if (locale === "fr") return fr_away(inputs)
	if (locale === "tl") return tl_away(inputs)
	if (locale === "vi") return vi_away(inputs)
	if (locale === "ko") return ko_away(inputs)
	if (locale === "de") return de_away(inputs)
	if (locale === "ru") return ru_away(inputs)
	if (locale === "tr") return tr_away(inputs)
	if (locale === "it") return it_away(inputs)
	if (locale === "pl") return pl_away(inputs)
	if (locale === "uk") return uk_away(inputs)
	if (locale === "hi") return hi_away(inputs)
	if (locale === "ar") return ar_away(inputs)
	if (locale === "ms") return ms_away(inputs)
	if (locale === "bn") return bn_away(inputs)
	if (locale === "zh-TW") return zh_tw2_away(inputs)
	if (locale === "zh-HK") return zh_hk2_away(inputs)
	if (locale === "ur") return ur_away(inputs)
	if (locale === "fa") return fa_away(inputs)
	if (locale === "sw") return sw_away(inputs)
	if (locale === "nl") return nl_away(inputs)
	return en_away(inputs)
});